import { LiveServiceFile, LiveServiceFileCollection, LiveServiceFormDataBase } from "../_services/cue-base.service";

export class UPN implements LiveServiceFormDataBase{
    autoswipe?: boolean;
    cooldown: number;
    locationTitle?: string;
    locationSubtitle?: string;
    dismissText: string;
    firstButtonLat?: number;
    firstButtonLng?: number;
    firstButtonText?: string;
    firstButtonType?: string;
    firstButtonUrl?: string;
    firstButtonLocationTitle?: string;
    firstButtonLocationSubtitle?: string;
    firstImage?: string;
    id?: number;
    lat?: number;
    lng?: number;
    secondButtonLat?: number;
    secondButtonLng?: number;
    secondButtonText?: string;
    secondButtonType?: string;
    secondButtonUrl?: string;
    secondButtonLocationTitle?: string;
    secondButtonLocationSubtitle?: string;
    secondImage?: string;
    thirdImage?: string;
    title: string;
    type: string;
    iframeUrl?: string;
    upnJson: any;
    bleEnabled: boolean;
    bleTitle: string;
    bleSubtitle: string;
    bleBody: string;
    bleShowOnTap: boolean;
    coupon1Id: number;
    coupon2Id: number;
    useAudible: boolean;
    regenerateAudio: boolean;

    activePeriod: {
        startDate: string,
        endDate: string
    };

    dateCreated: Date;
    serviceFiles: UPNServiceFileCollection;
}

export class UPNServiceFileCollection implements LiveServiceFileCollection {
    files: UPNServiceFile[];

    constructor() {

        this.files = [];
    }
}

export class UPNServiceFile implements LiveServiceFile {
    file: File;
    fileType: UPNFileType
}

export enum UPNFileType {
    FirstImage,
    SecondImage,
    ThirdImage
}
